export const SHEET_RANGE = 'B3:J200'
export const ADDRESS_LIMIT = 100

export enum PropertyAttachmentsValidationMessages {
  InvalidAttachment = 'Ogiltig Excel-mall har laddats upp. Använd mallen som bifogas detta formulär.',
  TooManyAddresses = 'Summan av dina uppladdade adresser överstiger 100 adresser. Endast 100 adresser är tillåtna per beställning.'
}

export const SESSION_EXPIRATION_MESSAGE = 'Din bankID-session har gått ut, logga in med bankID igen för att fortsätta'
